import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false,
        loadingTip: ''
    },
    mutations: {
        showLoading(state: any, opt?: any) {
            state.loadingTip = opt === undefined || !opt.tips ? '加载中，请稍等……' : opt.tips;
            state.loading = true;
        },
        hideLoading(state) {
            state.loading = false;
        },
        login(state, provider) {
            state.hasLogin = true;
            state.userInfo = provider;
            window.localStorage.setItem('userInfo', provider);
        },
        logout(state) {
            state.hasLogin = false;
            state.userInfo = {};
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('schoolInfo');
        }
    },
    actions: {},
    modules: {}
});
